'use strict';

export default {
  setSoParams(state, obj) {
    state.soParams = obj;
  },
  setCompanyInfo(state, obj) {
    state.soCompanyInfo = obj;
  },
  setEmailList(state, obj) {
    state.soEmailList = obj;
  },
  setHistory(state, obj) {
    state.soHistory = obj;
  },
  setHistoryList(state, obj) {
    state.soHistoryList = obj;
  },
  setCidStatus(state, status) {
    state.submitCid = status;
  },
  setSoLoaded(state,status){
    state.soLoaded=status;
  },
  setScrollItems(state,items){
    state.scrollItems=items;
  },
  setCrmInfo(state,info){
    state.crmInfo=info;
  },
  setSearchType(state,type){
    state.soSearchType=type;
  },
  setSearchEmailInCompany(state,position){
    state.searchEmailInCompany=position;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/so/mutations.js